import { AuthenticationAppRoutes } from "./AuthenticationAppRoutes";
import { AppLogo } from "./features/app/AppLogo";
import { AppStoresPush } from "./features/app/AppStoresPush";
import { AssistancePush } from "./features/assistance/AssistancePush";
import { BannersLandscape } from "./features/banners/BannersLandscape";
import { CompanyAnchor } from "./features/company/CompanyAnchor";
import { AppendicesNav } from "./features/core/AppendicesNav";

import "./AuthenticationApp.scss";

const classNamePrefix = "AuthenticationApp";

export const AuthenticationApp = () => (
  <div className={classNamePrefix}>
    <header className={`${classNamePrefix}-header`}>
      <div className={`${classNamePrefix}-appLogo`}>
        <AppLogo />
      </div>
      <div className={`${classNamePrefix}-companyAnchor`}>
        <CompanyAnchor />
      </div>
    </header>
    <main className={`${classNamePrefix}-main`}>
      <div className={`${classNamePrefix}-routes`}>
        <AuthenticationAppRoutes />
      </div>
      <div className={`${classNamePrefix}-ad`}>
        <BannersLandscape />
      </div>
    </main>
    <footer className={`${classNamePrefix}-footer`}>
      <div>
        <div className={`${classNamePrefix}-more`}>
          <div className={`${classNamePrefix}-assistanceHotlinePush`}>
            <AssistancePush />
          </div>
          <div className={`${classNamePrefix}-appStoresPush`}>
            <AppStoresPush />
          </div>
        </div>
        <div className={`${classNamePrefix}-appendicesNav`}>
          <AppendicesNav />
        </div>
      </div>
    </footer>
  </div>
);
